import { render, staticRenderFns } from "./IncomeWhitelistBtn.vue?vue&type=template&id=796be4b8&scoped=true"
import script from "./IncomeWhitelistBtn.vue?vue&type=script&lang=js"
export * from "./IncomeWhitelistBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796be4b8",
  null
  
)

export default component.exports